import {FC, useEffect, useMemo, useState} from "react";
import {ResultSearchContent} from "../../Sidebar/styles";
import IconToggleArrow from "../../../assets/icons/icon-toogle-arrow.svg";
import {IDataForSearchSidebar, ITypeRadar} from "../../../types";
import {colors} from "../../../mocks/projectsMock";
import CardItem from "../../CardItem";
import {SidebarTab} from "../../Sidebar";
import {
  IClusterDataFromServer,
  ITehnologieByClusterFromServer,
} from "../../../pages/Dashboard/Dashboard.type";

interface IProps {
  searchDatasidebarInfo?: IDataForSearchSidebar;
  isShowTitleParams: boolean;
  id: string | number;
  directionId: number | string;
  name: string;
  openSidebarWithTab: (
    tab: SidebarTab,
    directionId: number | string,
    clussterId?: number | string,
    name?: any,
    sectionName?: any,
    innerColor?: {back: string; color: string},
    nameTehnology?: string,
    idTehnology?: string,
    typeRadar?: ITypeRadar
  ) => void;
  typeRadar: ITypeRadar;
  allClusters?: IClusterDataFromServer[];
}

export const SidebarCardSearchClustersItem: FC<IProps> = ({
  searchDatasidebarInfo,
  isShowTitleParams,
  id: clusterId,
  directionId,
  name: clusterName,
  openSidebarWithTab,
  typeRadar,
  allClusters,
}) => {
  const [showDirectionsBlock, setShowDirectionsBlock] = useState(true);

  const [quantitiesItemsToShow, setQuantitiesItemsToShow] = useState(2);
  const handleShowMoreQuantitiesItem = () => {
    setQuantitiesItemsToShow((prev) => prev + 2);
  };
  const toggleDirectionsBlock = () => {
    setShowDirectionsBlock((prev) => !prev);
  };

  const resultFind = useMemo(() => {
    return allClusters
      ?.filter((itemCluster) => clusterId === itemCluster.documentId)
      .flatMap((cluster) => cluster.technologies || []);
  }, [allClusters, clusterId]);

  useEffect(() => {
    setQuantitiesItemsToShow(2);
  }, [searchDatasidebarInfo]);

  const handleCardClick = (technolieId: string, technologieName: string) => {
    const directionTitle = searchDatasidebarInfo?.directions?.find(
      (item) => item.id === directionId
    );
    const segmentLabels =
      searchDatasidebarInfo?.directions &&
      searchDatasidebarInfo?.directions?.map((item) => {
        // if (typeRadar === "stateInitiative") return item.documentId;
        return item.id;
      });
    const color = segmentLabels
      ?.map((item, i) => (item === directionId ? colors[i] : null))
      .find((item) => item !== null);

    openSidebarWithTab(
      SidebarTab.CPU,
      directionTitle?.id ?? "",
      clusterId,
      clusterName,
      directionTitle?.name,
      color ?? undefined,
      technologieName,
      technolieId,
      typeRadar
    );
  };
  return (
    <div style={{marginTop: 20}}>
      <div className="titleSearchItem" style={{}}>
        <div
          style={{
            display: "flex",
            justifyContent: "start",
            alignItems: "center",
            gap: 10,
          }}
          onClick={toggleDirectionsBlock}
        >
          <div className="toggleArrowImg">
            <img
              src={IconToggleArrow}
              alt=""
              style={{
                rotate: `${showDirectionsBlock ? "0deg" : "180deg"}`,
                transition: "all 0.3s",
              }}
            />
          </div>
          <p
            style={{
              color: "#ffffff",
              fontSize: 16,
              fontWeight: 700,
            }}
          >
            {clusterName}
          </p>
        </div>
        <div
          style={{
            backgroundColor: "#4D525B",
            borderRadius: "20px",
            width: "auto",
            padding: "0 7px",
            color: "white",
            border: "1px solid ##22272B",
            fontSize: "15px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          {resultFind?.length}
        </div>
      </div>
      {showDirectionsBlock && (
        <>
          <div style={{display: "flex", flexDirection: "column", gap: 10}}>
            {resultFind?.slice(0, quantitiesItemsToShow).map((item: any) => {
              return (
                <>
                  <CardItem
                    key={item.id}
                    invest_volume_tier={item.invest_volume_tier}
                    market_volume_tier={item.market_volume_tier}
                    potential_volume_tier={item.potential_volume_tier}
                    trl_tier={item.trl_tier}
                    title={item.name}
                    isFlashFilterEnabled={item.growth_potential}
                    isCritical={item.critical}
                    isNational={item.national}
                    isGpb={item.gpb}
                    type={SidebarTab.Clusters}
                    onClick={() => handleCardClick(item.documentId, item.name)}
                    imageCard={item.image}
                    isShowTitleParams={isShowTitleParams}
                    typeRadar={typeRadar}
                    batteryRussia={item.battery_russia}
                    batteryWorld={item.battery_world}
                  />
                </>
              );
            })}
          </div>
          {quantitiesItemsToShow < (resultFind?.length ?? 0) && (
            <span
              style={{
                color: "#0f9fff",
                padding: "5px 10px",
                cursor: "pointer",
              }}
              onClick={handleShowMoreQuantitiesItem}
            >
              Показать больше
            </span>
          )}
        </>
      )}
    </div>
  );
};
